import Vue from 'vue'
import {
    Row,
    Button,
    Link,
    Menu,
    MenuItem,
    Submenu,
    Card,
    Carousel,
    CarouselItem,
} from 'element-ui'

Vue.use(Row)
Vue.use(Button)
Vue.use(Link)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Card)
Vue.use(Carousel)
Vue.use(CarouselItem)